import { Container as StyledContainer } from './Container.styles.js';

const Container = ({ children, bgColor, className }) => (
	<StyledContainer bgColor={bgColor} className={className}>
		{children}
	</StyledContainer>
);

export default Container;
